<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage cargo entries</small>
      </legend>
      <div></div>
      <div>
        <div class="cargosLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: blue"></i>loading cargoentries...
        </div>

        <vue-good-table
          :columns="columns"
          :rows="systemCargos"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Action'">
              <button
                v-b-tooltip.hover.bottom="'Edit cargoentry!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewCargo(props.row.id)"
              >
                <i class="fa fa-edit"></i> Edit Cargoentry
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter file reference"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter bill of landing"
          }
        },
        {
          label: "Cargo no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "cargo number"
          }
        },
        {
          label: "Cargo size",
          field: "cargo_size",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter cargo size"
          }
        },
        {
          label: 'Expiry Date',
          field: "expiry_date",
           type: "date",
          dateInputFormat: "yyyy-MM-dd", // expects 2018-03-16
          dateOutputFormat: "MMM do yyyy",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter expiry date"
          } // outputs Mar 16th 2018
        },
        {
          label: "Action",
          field: "Action",
          width: "122px",
          html: true
        }
      ]
    };
  },

  created() {
    this.loadCargos();
  },
  computed: {
      ...mapGetters(["systemCargos"])
  },
  methods: {
      ...mapActions(["loadCargos", "viewCargo"])
  }
};
</script>


// WEBPACK FOOTER //
// src/cargoentries/managecargoentries.vue